import { PageNouvelleDemande } from '../components/demande/nouvelle/PageNouvelleDemande';
import type { PrefillNouvelleDemande } from '../components/demande/nouvelle/useNouvelleDemande';
import { NouvelleDemandeAncienne } from './NouvelleDemandeAncienne';

/**
 * « Nouvelle demande » : le calendrier du mois et le panneau « Ma demande » (docs/DECISIONS.md §26). L'ancien assistant en trois étapes reste
 * joignable par #nouvelle?version=ancienne, le temps que la nouvelle page soit validée.
 */
export function NouvelleDemandePage({ prefill }: { prefill?: PrefillNouvelleDemande } = {}) {
  return prefill?.version === 'ancienne' ? <NouvelleDemandeAncienne prefill={prefill} /> : <PageNouvelleDemande prefill={prefill} />;
}
